import React, { useState, useEffect } from 'react';
import AppSidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';
import { Client, Databases, Storage, Query } from 'appwrite';

// Appwrite setup
const client = new Client();
client.setEndpoint('https://cloud.appwrite.io/v1').setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const MyKnowledgeHub = () => {
  const { currentUser } = useAuth();
  const [knowledgePosts, setKnowledgePosts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getImageUrl = (imageId) => {
    if (!imageId) return null;
    try {
      return storage.getFileView(BUCKET_ID, imageId);
    } catch (error) {
      console.error('Error getting image URL:', error);
      return '';
    }
  };

  useEffect(() => {
    const fetchKnowledgePosts = async () => {
      if (!currentUser) return;

      try {
        setLoading(true);
        const response = await databases.listDocuments(DATABASE_ID, COLLECTION_ID, [
          Query.equal('userId', currentUser.uid),
          Query.equal('contentType', 'Knowledge Hub'),
        ]);
        setKnowledgePosts(response.documents);
      } catch (error) {
        console.error('Error fetching knowledge hub content:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchKnowledgePosts();
  }, [currentUser]);

  if (!currentUser) {
    return <div className="flex items-center justify-center min-h-screen">Please log in.</div>;
  }

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="flex">
      <div className="sticky top-0 h-screen">
        <AppSidebar user={currentUser} />
      </div>
      <div className="ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen flex-1">
        <h1 className="text-2xl font-bold mb-4">My Knowledge Hub</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {knowledgePosts.length > 0 ? (
            knowledgePosts.map((item) => (
              <div key={item.$id} className="bg-white rounded-lg shadow-md overflow-hidden">
                {item.imageId && (
                  <img
                    src={getImageUrl(item.imageId)}
                    alt={item.title}
                    className="h-48 w-full object-cover"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Found';
                    }}
                  />
                )}
                <div className="p-4">
                  <h2 className="text-xl font-bold mb-2">{item.title || 'Untitled'}</h2>
                  {item.category && (
                    <div className="mb-2">
                      <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {item.category}
                      </span>
                    </div>
                  )}
                  {!item.isApproved && (
                    <p className="text-red-500 text-xs mb-2">Not approved</p>
                  )}
                  <p className="text-gray-700 whitespace-pre-line">{item.content}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500">No knowledge posts found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyKnowledgeHub;
